// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"823":"3c662fda","971":"7a188d22"}[chunkId] + ".chunk.js";
};